var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h1',{staticClass:"text-danger text-center my-4"},[_vm._v("Determinacy of Beams")]),_c('fix')],1)}
var staticRenderFns = []

export { render, staticRenderFns }